(() => {
  if (window.nvCartLoaded) return;
  window.nvCartLoaded = true;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-nv-cart-add], [data-nv-cart-remove], [data-nv-cart-key]');
    const drawer = document.querySelector('cart-drawer');
    if (!btn || !drawer) return;
    e.preventDefault();

    const r = window.routes || {};
    let url = `${r.cart_change_url || '/cart/change'}.js`;
    let body;
    if (btn.dataset.nvCartAdd) {
      url = `${r.cart_add_url || '/cart/add'}.js`;
      body = { items: [{ id: Number(btn.dataset.nvCartAdd), quantity: 1 }] };
    } else if (btn.dataset.nvCartRemove) {
      body = { id: btn.dataset.nvCartRemove, quantity: 0 };
    } else {
      body = { id: btn.dataset.nvCartKey, quantity: Number(btn.dataset.qty) };
    }

    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          ...body,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const state = await res.json();
      if (!res.ok || state.status) throw new Error();
      drawer.classList.toggle('is-empty', state.item_count === 0);
      drawer.renderContents(state);
      if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nv-cart', cartData: state });
      }
    } catch {
      btn.removeAttribute('aria-busy');
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings?.error || 'Não foi possível atualizar o carrinho.';
    }
  });
})();
